var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgBlogEmail = function SvgSvgBlogEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 3.938a.564.564 0 0 0-.563.562v.777l6.065 4.978a1.967 1.967 0 0 0 2.5 0l6.06-4.978V4.5a.564.564 0 0 0-.562-.563H2.25ZM1.687 7.46v6.04c0 .31.254.563.563.563h13.5c.31 0 .563-.254.563-.563V7.46l-4.993 4.1a3.656 3.656 0 0 1-4.64 0l-4.992-4.1ZM0 4.5a2.252 2.252 0 0 1 2.25-2.25h13.5A2.252 2.252 0 0 1 18 4.5v9a2.252 2.252 0 0 1-2.25 2.25H2.25A2.252 2.252 0 0 1 0 13.5v-9Z",
    fill: "currentColor"
  })));
};
export default SvgSvgBlogEmail;